// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Mrh-C","modalFooterButton":"ModalNotes_modalFooterButton__17tZT"};